import { render, staticRenderFns } from "./EzuikitVideo.vue?vue&type=template&id=4680a728&scoped=true"
import script from "./EzuikitVideo.vue?vue&type=script&lang=js"
export * from "./EzuikitVideo.vue?vue&type=script&lang=js"
import style0 from "./EzuikitVideo.vue?vue&type=style&index=0&id=4680a728&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4680a728",
  null
  
)

export default component.exports